<template>
	<div class="precount-wrapper">

		<Versus :class="{active: (intro && currentWord == 0 && currentPlayer == 0 && $store.state.players.length > 1)}" />

		<div class="im-ready" :class="{active: !intro}">
			<div class="buttons">
				<Button value="Sono pronto!" @click.native="imReady()" />
			</div>

			<div class="precount">
				<div class="player player1" v-if="currentData.color == 'orange'">
					<svg id="Raggruppa_535" data-name="Raggruppa 535" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="64.464" viewBox="0 0 40 64.464">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rettangolo_1937" data-name="Rettangolo 1937" width="40" height="64.464" fill="#c677ff"/>
    </clipPath>
  </defs>
  <g id="Raggruppa_534" data-name="Raggruppa 534" clip-path="url(#clip-path)">
    <path id="Tracciato_1153" data-name="Tracciato 1153" d="M34.469,34.062l.16-.237.262-.39a19,19,0,0,0,4.831-9.36A18.517,18.517,0,0,0,40,20.938a19.63,19.63,0,0,0-2.555-9.79,18.878,18.878,0,0,0-5.109-5.673L32.3,5.448l-.53-.369-.077-.047A26.191,26.191,0,0,0,18.916,1.578l-.268,0A104.907,104.907,0,0,1,7.939.106L7.881.094,7.821.084A5.666,5.666,0,0,0,6.855,0a5.438,5.438,0,0,0-5.4,4.4A5.2,5.2,0,0,0,2.2,8.158,9.788,9.788,0,0,0,.034,13.434a9.447,9.447,0,0,0,2.325,7.055A9.975,9.975,0,0,0,9.13,23.877c.274.022.552.033.826.033a10.105,10.105,0,0,0,6.435-2.3l.361-.254.056-.043a.78.78,0,0,1,.483-.166l.069,0a.771.771,0,0,1,.53.265.732.732,0,0,1,.182.553.751.751,0,0,1-.048.209,1.429,1.429,0,0,1-.081.153,30.883,30.883,0,0,1-2.68,2.984l-.03.03-.029.031A38.375,38.375,0,0,0,9.55,33.252a40.193,40.193,0,0,0-3.3,8.27,33.159,33.159,0,0,0-1.534,7.764c-.233,3.75-.46,7.406,1.863,10.647A10.91,10.91,0,0,0,11.507,63.7c.563.215,5.355,1.961,9.205-.708a10.518,10.518,0,0,0,3.658-5.071c.476-1.344,1.192-4.329,1.311-4.846.125-.539.218-.948.329-1.528.211-1.1.234-1.565.616-3.038a27.562,27.562,0,0,1,2.028-5.8,61.46,61.46,0,0,1,5.815-8.652" transform="translate(0)" fill="#fff"/>
    <path id="Tracciato_1154" data-name="Tracciato 1154" d="M58.535,31.281l-.4-.285A21.825,21.825,0,0,0,47.354,28.03c-.1,0-.211,0-.316,0a99.775,99.775,0,0,1-10.659-1.5,2.483,2.483,0,0,0-.872,4.89l.3.066q-.365.276-.711.575l-.124.081a7.147,7.147,0,0,0-2.8,4.978,6.732,6.732,0,0,0,11.1,5.653l.04-.035.384-.277a3.481,3.481,0,0,1,5.4,4.015,4.074,4.074,0,0,1-.295.573,30.612,30.612,0,0,1-2.885,3.348c-1.153,1.29-2.067,2.43-2.738,3.309a36.358,36.358,0,0,0-3.173,4.963,7.484,7.484,0,0,0-.491,1.192A7.308,7.308,0,0,0,46.5,69.332c3,.03,4.911-1.813,6.856-4.784l-.01-.008c5.707-8.631,5.182-7.7,6.446-9.755,1.365-2.221,4.36-4.93,4.834-8.475a18.235,18.235,0,0,0,.129-2.079,15.854,15.854,0,0,0-6.218-12.95" transform="translate(-28.444 -23.432)" fill="#c677ff"/>
    <path id="Tracciato_1155" data-name="Tracciato 1155" d="M79.105,415.69a6.5,6.5,0,1,0,6.5,6.5,6.5,6.5,0,0,0-6.5-6.5" transform="translate(-64.228 -367.745)" fill="#c677ff"/>
    <path id="Tracciato_1156" data-name="Tracciato 1156" d="M134.273,310.5a1.6,1.6,0,1,1-1.722-1.463,1.6,1.6,0,0,1,1.722,1.463" transform="translate(-115.965 -273.393)" fill="#fff"/>
    <path id="Tracciato_1157" data-name="Tracciato 1157" d="M139.836,316.515a.9.9,0,1,1-1.033-.742.9.9,0,0,1,1.033.742" transform="translate(-122.127 -279.342)" fill="#13110c"/>
    <path id="Tracciato_1158" data-name="Tracciato 1158" d="M154.535,324.239a.792.792,0,0,1-.755-1.01l.213-.733a.347.347,0,1,1,.666.193l-.212.733a.1.1,0,0,0,.136.111l.07-.037a.347.347,0,0,1,.323.613l-.071.037a.792.792,0,0,1-.37.093" transform="translate(-136.015 -285.079)" fill="#13110c"/>
    <path id="Tracciato_1159" data-name="Tracciato 1159" d="M176.326,291.3a.35.35,0,0,1-.073-.008l-1.983-.426a.347.347,0,1,1,.145-.678l1.983.426a.347.347,0,0,1-.072.685" transform="translate(-153.927 -256.714)" fill="#13110c"/>
    <path id="Tracciato_1160" data-name="Tracciato 1160" d="M171.638,317.542a.347.347,0,0,1-.257-.579,1.987,1.987,0,0,1,2.56-.33.347.347,0,0,1-.378.581,1.294,1.294,0,0,0-1.668.215.346.346,0,0,1-.257.114" transform="translate(-151.535 -279.827)" fill="#13110c"/>
    <path id="Tracciato_1161" data-name="Tracciato 1161" d="M129.832,280.391a.347.347,0,0,1-.253-.584,2.029,2.029,0,0,1,2.313-.409.347.347,0,0,1-.3.626,1.35,1.35,0,0,0-1.51.257.346.346,0,0,1-.253.109" transform="translate(-114.551 -247.004)" fill="#13110c"/>
    <path id="Tracciato_1162" data-name="Tracciato 1162" d="M165.656,343.266a1.14,1.14,0,0,1-1.053-.692.347.347,0,0,1,.639-.27.454.454,0,0,0,.6.231.465.465,0,0,0,.251-.25.435.435,0,0,0,0-.339.347.347,0,0,1,.639-.27,1.123,1.123,0,0,1,0,.876,1.166,1.166,0,0,1-1.073.713" transform="translate(-145.594 -302.081)" fill="#13110c"/>
  </g>
</svg>

				</div>

				<div class="player player2" v-if="currentData.color == 'pink'">
					<svg id="Raggruppa_533" data-name="Raggruppa 533" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="298.926" height="518.052" viewBox="0 0 298.926 518.052">
						<defs>
							<clipPath id="clip-path">
								<rect id="Rettangolo_1936" data-name="Rettangolo 1936" width="298.926" height="518.052" fill="#e5efff"/>
							</clipPath>
						</defs>
						<g id="Raggruppa_532" data-name="Raggruppa 532" clip-path="url(#clip-path)">
							<path id="Tracciato_1143" data-name="Tracciato 1143" d="M120.564,518.052a81.919,81.919,0,0,1-81.894-79.8A93.479,93.479,0,0,1,2.312,382.539a98.648,98.648,0,0,1,13.5-74.716,94.007,94.007,0,0,1,17.624-20.094,147.747,147.747,0,0,1-28.96-89.984c.728-53.516,29.587-101.373,77.194-127.9A158.207,158.207,0,0,1,102.4,60.119,81.9,81.9,0,0,1,262.867,89.774,98.243,98.243,0,0,1,285.1,132.567c5.9,24.9,1.69,51.254-11.549,72.313a103.241,103.241,0,0,1-8.853,12.024,157.819,157.819,0,0,1,33.675,83.827l.044.506c3.458,42.206-10.653,84.073-38.72,114.889a160.143,160.143,0,0,1-60.235,41.952,81.676,81.676,0,0,1-78.893,59.974" fill="#fff"/>
							<path id="Tracciato_1144" data-name="Tracciato 1144" d="M119.987,483.7a47.55,47.55,0,0,1-46.871-55.585l1.413-8.23Q68.053,416.7,61.915,412.9a59.308,59.308,0,0,1-26.649-37.841,64.091,64.091,0,0,1,8.8-48.538,62.122,62.122,0,0,1,46.765-27.634l.441-.033c1.284-.089,2.589-.133,3.879-.133h.18l.139-.809a108.6,108.6,0,0,1-24.179-18.063,113.2,113.2,0,0,1-33.034-81.519c.561-41.193,22.824-78,59.566-98.471a126.276,126.276,0,0,1,33.871-12.991l2.234-13.012A47.539,47.539,0,1,1,227.63,89.938l-2.2,12.807a63.862,63.862,0,0,1,25.66,37.742c3.79,15.992,1.163,32.8-7.205,46.11-8.411,13.318-20.264,22.327-34.318,26.35,30.358,19.927,50.669,53.641,54.008,90.854l.021.241c2.686,32.78-8.227,65.218-29.943,89.021A125.51,125.51,0,0,1,169,431.548l-2.172,12.65a47.422,47.422,0,0,1-46.834,39.5Z" fill="#f251a5"/>
							<path id="Tracciato_1145" data-name="Tracciato 1145" d="M157.532,131.511A13.851,13.851,0,1,1,142.6,118.83a13.851,13.851,0,0,1,14.93,12.681" fill="#fff"/>
							<path id="Tracciato_1146" data-name="Tracciato 1146" d="M152.336,132.046a7.8,7.8,0,1,1-8.958-6.434,7.8,7.8,0,0,1,8.958,6.434" fill="#13110c"/>
							<path id="Tracciato_1147" data-name="Tracciato 1147" d="M194.485,132.184a13.851,13.851,0,1,1-14.93-12.681,13.851,13.851,0,0,1,14.93,12.681" fill="#fff"/>
							<path id="Tracciato_1148" data-name="Tracciato 1148" d="M188.991,132.816a7.8,7.8,0,1,1-8.958-6.434,7.8,7.8,0,0,1,8.958,6.434" fill="#13110c"/>
							<path id="Tracciato_1149" data-name="Tracciato 1149" d="M159.363,149.325a6.916,6.916,0,0,1-6.593-8.824l1.843-6.354a3.057,3.057,0,1,1,5.872,1.7l-1.842,6.354a.771.771,0,0,0,1.1.9l.612-.322a3.057,3.057,0,1,1,2.848,5.41l-.612.322a6.911,6.911,0,0,1-3.228.812" fill="#13110c"/>
							<path id="Tracciato_1150" data-name="Tracciato 1150" d="M155.551,125.566a3.058,3.058,0,0,1-.425-.03l-26.771-3.724a3.058,3.058,0,1,1,.842-6.057l26.771,3.725a3.058,3.058,0,0,1-.417,6.086" fill="#13110c"/>
							<path id="Tracciato_1151" data-name="Tracciato 1151" d="M169.582,125.566a3.058,3.058,0,0,1-.417-6.086l26.771-3.725a3.058,3.058,0,1,1,.842,6.057l-26.771,3.724a3.059,3.059,0,0,1-.425.03" fill="#13110c"/>
							<path id="Tracciato_1152" data-name="Tracciato 1152" d="M150.613,163.673a3.058,3.058,0,0,1-1.6-5.665l7.628-4.673a3.059,3.059,0,0,1,3.194,0l6.03,3.694,6.026-3.693a3.058,3.058,0,0,1,3.2,0l6.027,3.693,6.025-3.693a3.06,3.06,0,0,1,3.2,0l7.62,4.673a3.057,3.057,0,1,1-3.2,5.212l-6.022-3.693-6.025,3.694a3.06,3.06,0,0,1-3.2,0l-6.027-3.694-6.025,3.694a3.058,3.058,0,0,1-3.2,0l-6.031-3.694-6.031,3.694a3.046,3.046,0,0,1-1.594.451" fill="#13110c"/>
						</g>
					</svg>
				</div>

				<div>
					<Background :color="currentData.color" :rotating="true"/>
				</div>

			</div>
		</div>

	</div>
</template>

<script>
import Background from '@/components/Background.vue';
import Button from '@/components/Button.vue';
import Versus from '@/components/Versus.vue';

export default {
	components: {Background, Button, Versus},
	props: ['currentData','currentWord','currentPlayer','players'],
	data() {
		return {
			intro: true,
		}
	},
	methods: {
		imReady() {
			this.$emit('start',true);
		},
	},
	mounted() {
		this.intro = true;
		if(this.currentWord == 0 && this.currentPlayer == 0 && this.$store.state.players.length > 1) {
			this.playAudio('yooo', true);
			setTimeout(() => {
				this.playAudio('tititi');
				this.intro = false;
			},3000);
		}
		else {
			this.playAudio('tititi',true);
			this.intro = false;
		}
		
		
	}
}
</script>
<style scoped lang="scss">
	.precount-wrapper {
		transition: 0.3s all;
		opacity: 1;
		
		.buttons {
			position: fixed;
			bottom: 7vh;
			z-index: 99999;
			display: flex;
			justify-content: center;
			width: 100%;
			.button {
				z-index: 9999;
			}
		}

		.versus {
			pointer-events: none;
			opacity: 0;
			transition: all 0.3s;
			&.active {
				pointer-events: auto;
				opacity: 1;
			}
		}

		.im-ready {
			opacity: 0;
			z-index: 99999;
			position: fixed;
			transition: 0.3s all;
			pointer-events: none;
			&.active {
				pointer-events: auto;
				opacity: 1;
				z-index: 9999999;
			}
		}

		.precount {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
			background: $mondadori-yellow;
			z-index: 9999;
			transition: 0.3s all;
			pointer-events: none;

			
			.player {
				position: fixed;
				left: 0;
				right: 0;
				bottom: 0;
				height: 100%;
				display: flex;
				align-items: center;
				z-index: 9999;
				transition: all 1s;


				svg {
					transform: translate(-50%,-50%);
					width: 100%;
					height: 100%;
					max-width: 25rem;
					left: 50%;
					top: 50%;
					max-height: 25rem;
					pointer-events: all;
					position: absolute;
				}
			}

		
			.time {
				-webkit-text-stroke: 1rem;
				-webkit-text-stroke-color: white;
				-webkit-text-stroke-width: thin;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				font-size: px(220);
				display: inline-block;

				&.time-1 {
					color: $mondadori-blue;
				}
				
				&.time-2 {
					color: $mondadori-blue;
				}
				&.time-3 {
					color: $mondadori-blue;
				}

			}
		}
	}
</style>